<template>
  <div class="page_chili" style="height:1000px">
    <el-row style="text-align: right">
      <el-col>
        <el-radio v-model="radioPage3" label="1" @change="GetData">实时</el-radio>
        <el-radio v-model="radioPage3" label="2" @change="GetData">天</el-radio>
        <el-radio v-model="radioPage3" label="3" @change="GetData">月</el-radio>
        <el-radio v-model="radioPage3" label="4" @change="GetData">年</el-radio>
        <el-date-picker
          v-model="DatePage3"
          type="date"
          placeholder="选择日期"
          @change="GetData"
        ></el-date-picker>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" class="span3Css">
        <el-radio-group
          v-model="test"
          @change="GetData()"
          size="mini"
          text-color="red"
          fill="#EEEEEE"
          style="padding: 10, 5, 10, 5"
        >
          <el-radio-button
            style="display: block"
            v-for="(item, i) in items"
            :label="item.content"
            :key="i"
            :disabled="item.disabled"
            :checked="item.checked"
          >
            <div style class="Transbox">
              <img
                src="../../Imag/ja.png"
                style="width: 120px; height: 100px; border: 1px"
              />
              <br />
              <span>{{ item.id }}</span>
            </div>
          </el-radio-button>
        </el-radio-group>
      </el-col>
      <el-col :span="15" style="height: 100%; padding: 20px;backgroup-color:red">
        <span class="h4title">三相电流曲线</span>
        <br />
        <div class="tableTitle">
          <span class="midText"></span>
        </div>
        <div id="Page4_1" style="width: 1000px; height: 600px"></div>
      </el-col>
      <el-col :span="6" style="height: 100%">
        <el-row>
          <br />
          <span class="h4title">平均负载率</span>
          <br />
          <div class="tableTitle">
            <span class="midText"></span>
          </div>
          <div
            id="Page4_2"
            style="width: 400px; height: 300px; padding: 0px"
          ></div>
        </el-row>

        <el-row>
          <span>平均三相不平衡率:{{ Irate }}%</span>
          <br />
          <span>不&nbsp;&nbsp;平&nbsp;&nbsp;衡 &nbsp;&nbsp;率&nbsp;限&nbsp;值&nbsp;:{{ limit }}%</span>
          <br />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import echarts from "echarts";
import request from "../../utils/request";
export default {
  data() {
    return {
      msg: "",
      sites: [{ name: "Runoob" }, { name: "Google" }, { name: "Taobao" }],
      radioPage3: "1",
      DatePage3: new Date(),
      DataValuePage3: [],
      titlePage: "",
      test: '1',
      Irate: "",
      limit: "",
      items: [
         { id: "一期1#变", content: "1", disabled: false, checked: true },
        { id: "一期2#变", content: "2", disabled: false, checked: false },
        { id: "三期1#变", content: "4", disabled: false, checked: false },
        { id: "二期1#变", content: "5", disabled: false, checked: false },
        { id: "二期2#变", content: "6", disabled: false, checked: false },
        { id: "金桥35kv主变", content: "7", disabled: false, checked: false },
        { id: "金桥10KV备用变", content: "8", disabled: false, checked: false },
      ],
    };
  },
  mounted() {
    this.GetData();
  },
  methods: {
    getValue() {
      console.log(this.test);
    },
    GetData() {
      var sizeForm = {
        TimeTypePage3: parseInt(this.radioPage3),
        DateTimePage3: this.DatePage3,
        TransformerID: this.test,
      };
      request({
        url: "MeterTrans/GetPage4Data",
        method: "post",
        data: sizeForm,
      }).then((response) => {
        var that = this;
        console.log(response.data);
        // that.anchor = response.data.rust;
        // that.data = response.data.rust2[1];
        this.drawLine(response);
      });
    },
    drawLine(va) {
      // 基于准备好的dom，初始化echarts实例
      var chart1 = echarts.init(document.getElementById("Page4_1"));
      var data = "";
      var data1 = "";
      var data2 = "";
      var data3 = "";
      var data4 = "";
      var data23 = "";
      var data24 = "";

      if (va.data.code == "1") {
        var data = va.data.ia;
        var data1 = va.data.ib;
        var data2 = va.data.ic;
        var data3 = va.data.ip;
        var data4 = va.data.im;
        var anchor = va.data.startEndTime;
        this.Irate = va.data.Irate;
        this.limit = va.data.limit;
        var pveLoad = va.data.Irate;
      }
      if (va.data.code == "2") {
        data24 = va.data.KArr;
        var anchor = va.data.Date;
        this.Irate = va.data.Ru3.value;
        this.limit = va.data.Tvalue;
        var pveLoad = va.data.Ru3.value;
      }
      var optionPage4_1 = {
        title: {
          text: "",
        },
        color:['#2878CC','#1ACE93','#0D4885','#5B9FE6','#4034D3'],
        textStyle: {
          color: "#fff",
          fontStyle: "normal",
          fontFamily: "微软雅黑",
          fontSize: 12,
        },
        tooltip: {
          trigger: "axis",
          formatter: (params) => {  //格式化数据的函数
              console.log('我的参数',params[0].value)  //打印出来的数据（营业，网络，房屋，tgtn,g）
              return "A相电流<br/>"+ params[0].value[1]+
              "<br/>B相电流<br/>"+ params[1].value[1]+
              "<br/>C相电流<br/>"+ params[2].value[1]+
              "<br/>三相不平衡率<br/>"+ params[3].value[1]+
              "<br/>三相不平衡率限值<br/>"+ params[4].value[1];
            }
        },
        grid: {
          x: 25,
          y: 25,
          x2: 5,
          y2: 20,
          top: "100px",
          bottom: "15px",
          borderWidth: 1,
          containLabel: true,
        },
        toolbox: {
          feature: {
            restore: {},
            saveAsImage: {},
          },
        },
        legend: {
          color: "#fff",
          padding: [50, 0, 20, 0],
          data: ["A相电流", "B相电流", "C相电流", "不平衡率", "不平衡率限值"],
          textStyle: {
            color: "rgba(91, 127, 234, 1)",
          },
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            }, //区域缩放，区域缩放还原
            dataView: {
              readOnly: false,
            }, //数据视图
            magicType: {
              type: ["line", "bar"],
            }, //切换为折线图，切换为柱状图
            restore: {}, //还原
            saveAsImage: {}, //保存为图片
          },
        },
        xAxis: {
          type: "time",
          axisLine: {
            lineStyle: {
              color: "#0087ED",
              width: 1, //这里是为了突出显示加上的
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: [
          {
            name: "不平衡率%",
            type: "value",
            boundaryGap: [0, "100%"],
            axisLine: {
              lineStyle: {
                color: "#0087ED",
                width: 1, //这里是为了突出显示加上的
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            name: "单位:(A)",
            type: "value",
            boundaryGap: [0, "100%"],
            Max: 3000,
            axisLine: {
              lineStyle: {
                color: "#0087ED",
                width: 1, //这里是为了突出显示加上的
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "A相电流",
            type: "line",
            smooth: true,
            showSymbol: false,
            hoverAnimation: false,
            yAxisIndex: 1,
            data: data,
            symbol: "none", //不显示圆点
          },
          {
            name: "B相电流",
            type: "line",
            smooth: true,
            data: data1,
            yAxisIndex: 1,
            symbol: "none", //不显示圆点
          },
          {
            name: "C相电流",
            type: "line",
            smooth: true,
            data: data2,
            yAxisIndex: 1,
            symbol: "none", //不显示圆点
          },
          {
            name: "不平衡率",
            type: "line",
            smooth: true,
            data: data3,
            symbol: "none", //不显示圆点
            
                itemStyle: {
              normal: {
                lineStyle: {
                  color: "#5B9FE6",
                },
              },
            },
          },
          {
            name: "不平衡率限值",
            type: "line",
            smooth: true,
            data: data4,
            symbol: "none", //不显示圆点
             itemStyle: {
              normal: {
                lineStyle: {
                  color: "#4034D3",
                },
              },
            },
            

          },
          {
            name: ".anchor",
            type: "line",
            smooth: true,
            showSymbol: false,
            data: this.anchor,
            itemStyle: { normal: { opacity: 0 } },
            lineStyle: { normal: { opacity: 0 } },
             itemStyle: {
              normal: {
                lineStyle: {
                  color: "#AA00A2",
                },
              },
            },
          },
        ],
      };
      var Page4_Day_Option = {
        title: {
          text: "",
          subtext: "",
          sublink: "",
        },
        legend: {
          color: "#fff",
          padding: [50, 0, 20, 0],
          data: ['不平衡率'],
          textStyle: {
            color: "rgba(91, 127, 234, 1)",
          },
        },
        tooltip: {
          trigger: "axis",
         formatter: (params) => {  //格式化数据的函数
              console.log('我的参数',params[0].data[0])  //打印出来的数据（营业，网络，房屋，tgtn,g）
              return "电流不平衡率<br/>"+params[0].name+"<br/>最小值:"+ params[0].data[1]+"<br/>最大值:" + params[0].data[2];
            }
         },
        grid: {
          x: 25,
          y: 25,
          x2: 5,
          y2: 20,
          top: "100px",
          bottom: "15px",
          borderWidth: 1,
          containLabel: true,
        },
        xAxis: {
          name: "日期",
          type: "category",
          splitLine: { show: false },
          data: anchor,
           axisLine: {
            lineStyle: {
              color: "#0087ED",
              width: 1, //这里是为了突出显示加上的
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          name: "不平衡率%",
          type: "value",
           axisLine: {
            lineStyle: {
              color: "#0087ED",
              width: 1, //这里是为了突出显示加上的
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            text: '不平衡率',
            type: "k",
            data: data24,
            itemStyle: {
              //图形样式
              normal: { color: "#61a0a8" },
              lineStyle: {
              width: 2,
              color: '#61a0a8', // 阳线边框颜色
              color0: '#61a0a8' // 阴线边框颜色
              },


            },
          },
        ],
      };
      if (va.data.code == 1) {
        chart1.setOption(optionPage4_1);
      } else {
        chart1.clear();
        chart1.setOption(Page4_Day_Option);
      }
      console.log("echarts111");
      var chart32 = echarts.init(document.getElementById("Page4_2"));
      console.log(chart32);
      var optionPage3 = {
        tooltip: {
          formatter: "{a} <br/>{b} : {c}%",
        },
        grid: {
          x: 25,
          y: 45,
          x2: 5,
          y2: 20,
          borderWidth: 1,
        },
        toolbox: {
          feature: {
            restore: {},
            saveAsImage: {},
          },
        },
        series: [
          {
            name: "平均不平衡率",
            type: "gauge",
            startAngle: 180, //开始角度 左侧角度
            endAngle: 0,
            detail: { formatter: "{value}%" },
            data: [pveLoad],
          },
        ],
      };
      chart32.setOption(optionPage3, true);
    },
  },
};
</script>
<style>
@import "./page.css";
</style>